<template>
    <div class="counter-information">
        <div class="counter-information__header">
            {{ header ?? $t('generic["expired-link"]') }}
        </div>

        <div class="counter-information__counter">
            {{ $t('generic["you-will-be-redirected"]', [seconds]) }}
        </div>

        <div class="counter-information__continue">
            <button class="bnr-button red">
                {{ $t('generic["continue-button"]') }}
            </button>
        </div>
    </div>
</template>

<script>
import onEnter from '@/utils/functions/onEnter';
import { onMounted, ref } from 'vue';

export default {
    props: {
        expirationTime: {
            type: Number,
            default: 5
        },

        header: {
            type: String,
            default: null
        }
    },
emits: ['time-ended'],

    setup(props, { emit }) {
        const seconds = ref(props.expirationTime);
        const eventToDestroy = onEnter(onTimeEnd);

        onMounted(() => {
            startCounter();
        });

        function startCounter() {
            seconds.value -= 1;

            if (seconds.value <= 0) {
                onTimeEnd();

                return;
            }

            setTimeout(() => {
                startCounter();
            }, 1000);
        }

        function onTimeEnd() {
            eventToDestroy();
            emit('time-ended');
        }

        return {
            seconds
        };
    }
};
</script>

<style lang="scss" scoped>
.counter-information {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 25px;
    color: #450725;

    &__header {
        font-size: 1.2em;
    }

    .bnr-button {
        width: 240px;
    }
}
</style>
